module.exports = __webpack_public_path__ + "img/shanxinyue.86c8309b.jpg";